import { Stack } from "@mui/material";
import { useEffect } from "react";
import { useLoaderData } from "react-router-dom";

import PaginationControlsV2 from "../../../global/PaginationControlsV2";
import useContractPermissions from "../hooks/useContractPermissions";
import useContractsData from "../hooks/useContractsData";
import useEventHandlers from "../hooks/useEventHandlers";
import { useContractStore } from "../store/contractStore";

import ContractsAddButton from "./ContractsAddButton";
import ContractsDeleteModal from "./ContractsDeleteModal";
import ContractsEditModal from "./ContractsEditModal";
import ContractsTable from "./ContractsTable";

export default function Contracts() {
  const { id: entityId } = useLoaderData();
  const { canAddContract, canEditContract, canDeleteContract, canViewContract } =
    useContractPermissions();
  const { reset, data, loading, resultCount, currentPage, resLimit, setCurrentPage } =
    useContractStore();
  const { fetchContractsData } = useContractsData(entityId, canViewContract);
  const {
    modalState,
    isDeleting,
    handleDelete,
    handlePageChange,
    handleOpenAddModal,
    handleOpenEditModal,
    handleOpenDeleteModal,
    handleCloseModal,
  } = useEventHandlers({ fetchContractsData, setCurrentPage });

  useEffect(() => reset, [reset]);

  if (!canViewContract) {
    return null;
  }

  return (
    <>
      <div className="flex h-full flex-col gap-4">
        <div className="flex w-full flex-row items-center justify-end">
          {canAddContract && <ContractsAddButton handleAdd={handleOpenAddModal} />}
        </div>
        <div className="relative flex flex-1 flex-col gap-2 overflow-y-auto">
          <ContractsTable
            data={data}
            isLoading={loading}
            onDelete={handleOpenDeleteModal}
            onEdit={handleOpenEditModal}
            canEdit={canEditContract}
            canDelete={canDeleteContract}
          />
        </div>
        {resultCount > resLimit && (
          <div className="relative flex w-full justify-center">
            <Stack alignItems="center">
              <PaginationControlsV2
                currentPage={currentPage}
                handleChange={handlePageChange}
                resultCount={resultCount}
                resultLimit={resLimit}
              />
            </Stack>
          </div>
        )}
      </div>

      <ContractsEditModal
        openModal={modalState.mode === "add" || modalState.mode === "edit"}
        handleCloseModal={handleCloseModal}
        contractData={modalState.contract}
        entityId={entityId}
        mode={modalState.mode}
        onSaveSuccess={fetchContractsData}
      />
      <ContractsDeleteModal
        openModal={modalState.mode === "delete"}
        handleCloseModal={handleCloseModal}
        handleDelete={handleDelete}
        isDeleting={isDeleting}
      />
    </>
  );
}
